module.exports = {"511822001":"严道街道","511822101":"花滩镇","511822102":"龙苍沟镇","511822103":"牛背山镇","511822104":"新添镇","511822105":"青龙镇","511822106":"荥河镇","511822107":"五宪镇","511822202":"安靖乡","511822203":"民建彝族乡","511822207":"泗坪乡","511822212":"宝峰彝族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511822.json
// module id = 2513
// module chunks = 0